import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "plan-name" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "benefits-values" }
const _hoisted_4 = { class: "d-flex flex-column align-items-end" }
const _hoisted_5 = {
  key: 0,
  class: "value-text"
}
const _hoisted_6 = {
  key: 1,
  class: "value-text"
}
const _hoisted_7 = {
  key: 2,
  class: "value-text"
}
const _hoisted_8 = { class: "d-flex justify-content-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex-column",
    style: _normalizeStyle({
      display: $setup.props.showScreen ? 'flex' : 'none'
    })
  }, [
    _createElementVNode("p", _hoisted_1, "Plano " + _toDisplayString($setup.reqRenewBenCardsPlanStore.benefitsCardsPlan?.getPlanName()), 1 /* TEXT */),
    _cache[12] || (_cache[12] = _createElementVNode("div", { style: {"height":"var(--semantic-size-semantic-spacing-stack-300, 24px)"} }, null, -1 /* HOISTED */)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["FontAwesomeIcon"], {
        icon: $setup.Icons.imported.faCalendarRegular,
        style: {
          width: 'var(--semantic-size-semantic-size-icons-200, 16px)',
          height: 'var(--semantic-size-semantic-size-icons-200, 16px)',
          color: 'var(--semantic-color-fg-muted, #6E6979)',
        }
      }, null, 8 /* PROPS */, ["icon"]),
      _cache[9] || (_cache[9] = _createElementVNode("div", { style: {"width":"var(--semantic-size-semantic-spacing-inline-100, 8px)"} }, null, -1 /* HOISTED */)),
      _cache[10] || (_cache[10] = _createElementVNode("p", { class: "plan-text" }, "O plano será renovado assim que o pagamento for confirmado.", -1 /* HOISTED */))
    ]),
    _cache[13] || (_cache[13] = _createElementVNode("div", { style: {"height":"var(--semantic-size-semantic-spacing-stack-600, 48px)"} }, null, -1 /* HOISTED */)),
    _createElementVNode("div", _hoisted_3, [
      _createVNode($setup["BenefitTypeValue"], {
        ref: "benefitFoodVoucher",
        icon: $setup.Icons.imported.faCartShopping,
        title: "Vale alimentação",
        subtitle: "VA",
        value: $setup.FormatUtils.formatMoney($setup.reqRenewBenCardsPlanStore.getBenefitCategory($setup.CardCategoryType.VA), true),
        "initial-is-enabled": $setup.reqRenewBenCardsPlanStore.getBenefitCategory($setup.CardCategoryType.VA)?.length > 0,
        "input-icon": $setup.Icons.imported.faDollarSign,
        "error-text": $setup.reqRenewBenCardsPlanStore.getBenefitCategoryError($setup.CardCategoryType.VA) ?? undefined,
        "is-enabled": $setup.reqRenewBenCardsPlanStore.getBenefitCategoryActive($setup.CardCategoryType.VA),
        onSetIsEnabled: _cache[0] || (_cache[0] = (v) => $setup.reqRenewBenCardsPlanStore.setBenefitCategory({
            category: $setup.CardCategoryType.VA,
            value: '',
            isActive: v,
          })),
        onChange: _cache[1] || (_cache[1] = (v, isEnabled) => $setup.reqRenewBenCardsPlanStore.setBenefitCategory({
            category: $setup.CardCategoryType.VA,
            value: $setup.FormatUtils.formatMoney(v, true),
            isActive: isEnabled
          }))
      }, null, 8 /* PROPS */, ["icon", "value", "initial-is-enabled", "input-icon", "error-text", "is-enabled"]),
      _createVNode($setup["BenefitTypeValue"], {
        ref: "benefitMealVoucher",
        icon: $setup.Icons.imported.faPizzaSlice,
        title: "Vale refeição",
        subtitle: "VR",
        value: $setup.FormatUtils.formatMoney($setup.reqRenewBenCardsPlanStore.getBenefitCategory($setup.CardCategoryType.VR), true),
        "initial-is-enabled": $setup.reqRenewBenCardsPlanStore.getBenefitCategory($setup.CardCategoryType.VR)?.length > 0,
        "input-icon": $setup.Icons.imported.faDollarSign,
        "error-text": $setup.reqRenewBenCardsPlanStore.getBenefitCategoryError($setup.CardCategoryType.VR) ?? undefined,
        "is-enabled": $setup.reqRenewBenCardsPlanStore.getBenefitCategoryActive($setup.CardCategoryType.VR),
        onSetIsEnabled: _cache[2] || (_cache[2] = (v) => $setup.reqRenewBenCardsPlanStore.setBenefitCategory({
            category: $setup.CardCategoryType.VR,
            value: '',
            isActive: v,
          })),
        onChange: _cache[3] || (_cache[3] = (v, isEnabled) => $setup.reqRenewBenCardsPlanStore.setBenefitCategory({
            category: $setup.CardCategoryType.VR,
            value: $setup.FormatUtils.formatMoney(v, true),
            isActive: isEnabled,
          }))
      }, null, 8 /* PROPS */, ["icon", "value", "initial-is-enabled", "input-icon", "error-text", "is-enabled"]),
      _createVNode($setup["BenefitTypeValue"], {
        ref: "benefitMultiVoucher",
        icon: $setup.Icons.imported.faVanShuttle,
        title: "Auxílio mobilidade",
        value: $setup.FormatUtils.formatMoney($setup.reqRenewBenCardsPlanStore.getBenefitCategory($setup.CardCategoryType.AM), true),
        "initial-is-enabled": $setup.reqRenewBenCardsPlanStore.getBenefitCategory($setup.CardCategoryType.AM)?.length > 0,
        "input-icon": $setup.Icons.imported.faDollarSign,
        description: "Aceito em qualquer meio de locomoção",
        "error-text": $setup.reqRenewBenCardsPlanStore.getBenefitCategoryError($setup.CardCategoryType.AM) ?? undefined,
        "is-enabled": $setup.reqRenewBenCardsPlanStore.getBenefitCategoryActive($setup.CardCategoryType.AM),
        onSetIsEnabled: _cache[4] || (_cache[4] = (v) => $setup.reqRenewBenCardsPlanStore.setBenefitCategory({
            category: $setup.CardCategoryType.AM,
            value: '',
            isActive: v,
          })),
        onChange: _cache[5] || (_cache[5] = (v, isEnabled) => $setup.reqRenewBenCardsPlanStore.setBenefitCategory({
            category: $setup.CardCategoryType.AM,
            value: $setup.FormatUtils.formatMoney(v, true),
            isActive: isEnabled,
          }))
      }, null, 8 /* PROPS */, ["icon", "value", "initial-is-enabled", "input-icon", "error-text", "is-enabled"]),
      _createVNode($setup["BenefitTypeValue"], {
        ref: "benefitMultiVoucher",
        icon: $setup.Icons.imported.faEarthAmericas,
        title: "Vale flexível",
        value: $setup.FormatUtils.formatMoney($setup.reqRenewBenCardsPlanStore.getBenefitCategory($setup.CardCategoryType.MULTI), true),
        "initial-is-enabled": $setup.reqRenewBenCardsPlanStore.getBenefitCategory($setup.CardCategoryType.MULTI)?.length > 0,
        "input-icon": $setup.Icons.imported.faDollarSign,
        description: "Aceito em qualquer lugar",
        "error-text": $setup.reqRenewBenCardsPlanStore.getBenefitCategoryError($setup.CardCategoryType.MULTI) ?? undefined,
        "is-enabled": $setup.reqRenewBenCardsPlanStore.getBenefitCategoryActive($setup.CardCategoryType.MULTI),
        onSetIsEnabled: _cache[6] || (_cache[6] = (v) => $setup.reqRenewBenCardsPlanStore.setBenefitCategory({
            category: $setup.CardCategoryType.MULTI,
            value: '',
            isActive: v,
          })),
        onChange: _cache[7] || (_cache[7] = (v, isEnabled) => $setup.reqRenewBenCardsPlanStore.setBenefitCategory({
            category: $setup.CardCategoryType.MULTI,
            value: $setup.FormatUtils.formatMoney(v, true),
            isActive: isEnabled,
          }))
      }, null, 8 /* PROPS */, ["icon", "value", "initial-is-enabled", "input-icon", "error-text", "is-enabled"])
    ]),
    _cache[14] || (_cache[14] = _createElementVNode("div", { style: {"height":"var(--semantic-size-semantic-spacing-stack-300, 24px)"} }, null, -1 /* HOISTED */)),
    _createVNode($setup["Divider"]),
    _cache[15] || (_cache[15] = _createElementVNode("div", { style: {"height":"var(--semantic-size-semantic-spacing-stack-200, 16px)"} }, null, -1 /* HOISTED */)),
    _createElementVNode("div", _hoisted_4, [
      _cache[11] || (_cache[11] = _createElementVNode("p", { class: "total-by-collab" }, "Total por colaborador", -1 /* HOISTED */)),
      ($setup.reqRenewBenCardsPlanStore.benefitsCardsPlan?.getUserCount())
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, "R$ " + _toDisplayString($setup.FormatUtils.money($setup.reqRenewBenCardsPlanStore.getTotalValuePerUser())), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      (!$setup.reqRenewBenCardsPlanStore.benefitsCardsPlan?.getUserCount())
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Não há colaboradores no plano"))
        : _createCommentVNode("v-if", true),
      (!$setup.reqRenewBenCardsPlanStore.benefitsCardsPlan?.getTotalPlanValue())
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, "O plano deve ter saldo maior que R$ 0,00"))
        : _createCommentVNode("v-if", true)
    ]),
    _cache[16] || (_cache[16] = _createElementVNode("div", { style: {"height":"var(--semantic-size-semantic-spacing-stack-600, 48px)"} }, null, -1 /* HOISTED */)),
    _createElementVNode("div", _hoisted_8, [
      _createVNode($setup["CommonButton"], {
        onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.$emit('close'); $setup.reqRenewBenCardsPlanStore.$reset();}),
        type: "outlined",
        text: "Cancelar",
        action: "secondary"
      }),
      _createVNode($setup["CommonButton"], {
        action: $setup.reqRenewBenCardsPlanStore.benefitsCardsPlan?.getUserCount() && $setup.reqRenewBenCardsPlanStore.canRenew() ? 'cta' : 'disabled',
        onClick: $setup.updatePlan,
        text: "Confirmar valores do benefício"
      }, null, 8 /* PROPS */, ["action"])
    ])
  ], 4 /* STYLE */))
}